import { getPeritaje } from './getPeritaje'

export async function getPeritajeForPresupuestador(patente) {
  const { peritaje, peritajeQuote } = await getPeritaje(patente)
  let result = { peritado: peritaje.statusId, requestsId: peritaje.id }

  if (peritajeQuote) {
    result = {
      ...result,
      quotation_id: peritajeQuote.requestsId,
      year: peritajeQuote.verification.vehicle.year.label,
      brand: peritajeQuote.verification.vehicle.brand.label,
      model: peritajeQuote.verification.vehicle.model.label,
      version: peritajeQuote.verification.vehicle.version.label,
      versionId: peritajeQuote.verification.vehicle.version.value,
      patente: peritajeQuote.licencePlate,
      km: peritajeQuote.verification.kilometraje,
      precio: peritajeQuote.appraisal,
      peritado: peritajeQuote.verification.statusId,
      valorOriginal: peritajeQuote.appraisal,
      appraisal: peritajeQuote.appraisal,
      oldValue: peritajeQuote.appraisal,
      verificationDate: peritajeQuote.verification.verificationDate,
      appraisal_approved: peritajeQuote.appraisal_approved,
    }
  } else {
    throw new Error('La patente no está peritada')
  }

  return result
}
